import user from '../../api/user'

const pingCloud = function (store) {
  let pingCloud$i = null
  let pingCloudIntervalWhenOnline = 1000 * 10
  let pingCloudIntervalWhenOffline = 1000 * 5

  store.subscribe(mutation => {
    if (mutation.type === 'INTERNET_DISCONNECTED') {
      startPingCloud()
    } else if (mutation.type === 'INTERNET_CONNECTED') {
      stopPingCloud()
    }
  })

  function pingCloudWhenOnline () {
    setInterval(() => {
      pingCloud()
    }, pingCloudIntervalWhenOnline)
  }
  function startPingCloud () {
    stopPingCloud()
    pingCloud$i = setInterval(() => {
      pingCloud()
    }, pingCloudIntervalWhenOffline)
  }
  function stopPingCloud () {
    if (pingCloud$i) {
      clearInterval(pingCloud$i)
      pingCloud$i = null
    }
  }

  function pingCloud () {
    user.pingCloud().then(
      res => {
        store.dispatch('checkOnlineStatusByApiResponse', res)
      },
      err => {
        store.dispatch('checkOnlineStatusByApiResponse', err)
      }
    )
  }

  pingCloudWhenOnline()
}

export default pingCloud



// WEBPACK FOOTER //
// ./src/store/plugins/pingCloud.js